import React from "react";
import ReactPlayer from 'react-player';


const ReactNativeRealisations = () => {
    return (
        <div>
            <p className="pMemory ">Application mobile React Native/Redux/API REST WordPress réalisée lors de mon stage de formation pour un client l'entreprise. <br/>Elle permet a des patients de participer à un protocole de soins de certains troubles musculoshelatiques(nécessitant pas d'intervention médicale) dans le cadre d'une étude realisée par l'USACA (Université Santiago de Cali en Colombie) et NUMERILIS (INOLAM)<br/>Elle est destinée aux patients et soignants (kinés) qui les suivent pendant le protocole. </p>
           
            {/* <p>test</p> */}
            <div className="seresa mt-2">
                <div className="row">
                    <div className="col-md-6 ">
                        <div className="card1 col-md-12">
                            <p className="text-white text-center">Démonstration de la partie patient</p>
                            <ReactPlayer style={{ margin: 'auto', padding: 5 }} controls={true}
                                url='https://portfoli-omar-data.s3.eu-west-3.amazonaws.com/screen-recor-seresa2-patient.mp4'
                                width='100%'
                                height='300px'
                                fluid={"true"}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card1 col-md-12 my-1">
                            <p className="text-white text-center">Démonstration de la partie kiné</p>
                            <ReactPlayer style={{ margin: 'auto', padding: 5 }} controls={true}
                                url='https://portfoli-omar-data.s3.eu-west-3.amazonaws.com/screen-record-kine.mp4'
                                width='100%'
                                height='300px'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReactNativeRealisations;